import type {
  ProductCreateDTO,
  ProductResponceDTO,
  ProductUpdateDTO,
} from "../client"

export type ProductUnitWeightFields = {
  unit_weight_kg?: string | null
}

export type ProductWithUnitWeight = ProductResponceDTO & ProductUnitWeightFields

export type ProductCreateWithUnitWeight = ProductCreateDTO &
  ProductUnitWeightFields

export type ProductUpdateWithUnitWeight = ProductUpdateDTO &
  ProductUnitWeightFields

export function normalizeProductUnitWeight(raw: string): string | undefined {
  const trimmed = raw.trim()
  if (!trimmed || /\s/.test(trimmed)) return undefined
  const value = trimmed.replace(",", ".")
  if (!/^\d+(?:\.\d{1,4})?$/.test(value)) return undefined

  const [integerPart] = value.split(".")
  if (integerPart.length > 8 || /^0+(?:\.0{1,4})?$/.test(value)) {
    return undefined
  }
  return value
}

export function formatProductUnitWeight(value?: string | null): string {
  if (!value) return "—"
  const normalized = normalizeProductUnitWeight(value)
  return normalized ? `${normalized.replace(".", ",")} kg` : "—"
}
